// V2 copy of utils/formValidators/quoteFormInputCheck.js — behavior IDENTICAL
// to prod so the v2 quote form validates exactly the same. Copied (not imported)
// per the "make copies, don't reuse prod in place" constraint.
class FormTestV2 {
  constructor(formState) {
    this.name = formState.nameInput;
    this.email = formState.emailInput;
    this.city = formState.cityInput;
    this.phoneNumber = formState.phoneNumberInput;
    this.numberType = formState.numberType;
    this.heardABoutUs = formState.heardAboutUs;
    this.otherInput = formState.otherInput;
  }

  async testName() {
    return this.name === "" ? false : true;
  }

  async testEmail() {
    const emailRegex = /.+@.+\..+/;
    return emailRegex.test(this.email);
  }

  async testPhone() {
    if (this.phoneNumber > 0 && this.phoneNumber < 12) {
      return false;
    }

    const phoneRegex = /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    return phoneRegex.test(this.phoneNumber);
  }

  async testNumberType() {
    if (this.numberType?.length <= 0 || this.numberType === "") {
      return false;
    }

    return true;
  }

  async testCity() {
    return this.city !== "" && this.city?.trim().length > 0;
  }

  async testOther() {
    if (this.heardABoutUs === "Other") {
      return this.otherInput === "Other" || this.otherInput === ""
        ? false
        : true;
    }

    return true;
  }

  async formValid() {
    if (
      (await this.testName()) &&
      (await this.testEmail()) &&
      (await this.testCity()) &&
      (await this.testPhone()) &&
      (await this.testOther()) &&
      (await this.testNumberType())
    ) {
      return true;
    }

    return false;
  }
}

export default FormTestV2;
